import React, {useContext, useEffect, useState} from 'react';
import {View, Text, Image, Platform, Pressable, Switch} from 'react-native';
import MainStyle from '../../../../MainStyle';
import Button from 'components/Button';
import {Landing, smgEnvironment, Version} from '../../../constants';
import HelpLinkModalTrigger from '../../../modals/HelpLinksModal';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import {browser} from "../../../utils";
import {StoreContext} from "components/StoreContextProvider";
import add_to_home from '../../../assets/img/icons/add_to_home.png';
import about_company from '../../../assets/img/icons/about_company_icon.png';
import Div from "../../../lib/Div";
import kiosk_logo_RGB_1row from "../../../assets/img/evenplay-logo-long.svg";
import P from "../../../lib/P";

type SplashScreenProps = { navigation: any };

export const SplashScreen = ({navigation}: SplashScreenProps) => {
  const [installEvent, setInstallEvent] = useState<any>();
  const insets = useSafeAreaInsets();
  const Context = useContext(StoreContext);
  const {cancelModalConfig, isTest} = Context;

  const openAboutCompany = () => {
    if (Platform.OS === 'web') window.open(Landing, '_self');
  };

  const isInstalled = () => {
    if (Platform.OS !== 'web') return false;
    return window.matchMedia('(display-mode: standalone)').matches;
  };

  const AddToHomeScreen = () => {
    if (installEvent) {
      installEvent?.prompt();

    } else if (getMobileOperatingSystem() === 'iOS') {
      Context.setCancelModalConfig({
        visible: true, title: 'Add To Home Screen', titleColor: MainStyle.c_light_blue, leftBtnText: 'OK',
        subtitle: 'Tap on the “Share” button on your browser', secondary: 'Select “Add to Home Screen”',
        onExit: () => {
          Context.setCancelModalConfig({...cancelModalConfig, visible: false});
        }
      });

    } else if (getMobileOperatingSystem() === 'Android') {
      Context.setCancelModalConfig({
        visible: true, title: 'Add To Home Screen', titleColor: MainStyle.c_light_blue, leftBtnText: 'OK',
        subtitle: 'Tap on the menu button', secondary: 'Select the option labeled "Add to home screen"',
        onExit: () => {
          Context.setCancelModalConfig({...cancelModalConfig, visible: false});
        }
      });
    }
  };

  const getMobileOperatingSystem = () => {
    if (Platform.OS !== 'web') return '';
    const userAgent = navigator.userAgent || navigator.vendor;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) return "Windows Phone";

    if (/android/i.test(userAgent)) return "Android";

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent)) return "iOS";

    return "unknown";
  };

  const videoClick = () => {
    navigation.reset({index: 0, routes: [{name: 'LoginWithPin'}]});
  };

  useEffect(() => {
    console.log('getMobileOperatingSystem=', getMobileOperatingSystem());
    console.log('browser=', browser());

    const listener = (ev: Event) => {
      // Prevent the mini-infobar from appearing on mobile
      ev.preventDefault();
      // Stash the event so it can be triggered later.
      setInstallEvent(ev);
      console.log('saved the install event');
      // Update UI notify the user they can install the PWA
      // if you want here...
    };

    if (Platform.OS === 'web') {
      window.addEventListener('beforeinstallprompt', listener);
    }

    return () => {
      if (Platform.OS === 'web') {
        window.removeEventListener('beforeinstallprompt', listener);
      }
    };
  }, []);

  return (
    <>
      <HelpLinkModalTrigger page="splash" position="absolute" top={5} right={5}/>

      <Div flex={1} pt={insets.top}>
        <Div pt={24} pb={7}>
          <View style={styles.header_s}>
            <Div flexDir="column" alignItems="center">
              {/*<Text style={[...styles.title_s, MainStyle.c_title_blue]}>PLAY GOLF.</Text>*/}
              <Text style={[...styles.title_s, MainStyle.c_new_green_text]}>
                &nbsp;Tailored to your talent.&nbsp;
              </Text>
            </Div>
            {/*<Text style={[...styles.title_s, MainStyle.c_white]}>IT’S THAT SIMPLE.</Text>*/}
          </View>
        </Div>

        <View style={[MainStyle.flex1, MainStyle.p_x_27, MainStyle.relative]}>
          <Image source={kiosk_logo_RGB_1row as any} style={MainStyle.flex1} resizeMode="center"/>

          <Pressable
            onPress={videoClick}
            style={[MainStyle.absolute, MainStyle.t_0, MainStyle.r_0, MainStyle.b_0, MainStyle.l_0]}
          />
        </View>

        <Div py={19}>
          <Div w="100%" maxW={1205} mx="auto" position="relative" row justifyContent="space-between">
            <Div w={53} ml={10}>
              <Pressable style={MainStyle.a_i_c} onPress={openAboutCompany}>
                <Image source={about_company} style={[MainStyle.w_20, MainStyle.h_20, MainStyle.m_b_6]}/>
                <Text style={styles.btn_text}>About the Company</Text>
              </Pressable>
            </Div>

            <Div flexDir="column">
              <Button
                text="SIGN UP/IN" onPress={() => navigation.reset({index: 0, routes: [{name: 'LoginWithPin'}]})}
                w={180} h={24} fontSize={16} fontWeight="700" style={styles.btn_shadow}
              />

              <Div w={30} h={10}/>

              <Button
                text="BOOK NOW" w={180} h={24} fontSize={16} fontWeight="700" style={styles.btn_shadow}
                onPress={() => {
                  if (Platform.OS === 'web') window.open(Landing, '_self');
                }}
              />
            </Div>

            <Div w={53} mr={10}>
              {!isInstalled() && (getMobileOperatingSystem() === 'Android' || getMobileOperatingSystem() === 'iOS') && (
                <Pressable style={MainStyle.a_i_c} onPress={AddToHomeScreen}>
                  <Image source={add_to_home} style={[MainStyle.w_20, MainStyle.h_20, MainStyle.m_b_6]}/>
                  <Text style={styles.btn_text}>add to Home Screen</Text>
                </Pressable>
              )}
            </Div>
          </Div>
        </Div>
      </Div>

      {(smgEnvironment === 'external' || smgEnvironment === 'test') && (
        <Pressable style={[MainStyle.absolute, MainStyle.t_35, MainStyle.l_5, MainStyle.row, MainStyle.a_i_c]}
                   onPress={() => Context.setIsTest(!isTest)}>
          <P fw="600" fs={10} mr={7}>Test</P>

          <Switch
            trackColor={{false: '#767577', true: '#81b0ff'}} thumbColor={isTest ? '#f5dd4b' : '#f4f3f4'}
            ios_backgroundColor="#3e3e3e" value={isTest} onValueChange={() => Context.setIsTest(!isTest)}
          />
        </Pressable>
      )}

      <P position="absolute" top={9} left={15} color="#989898">
        {`${Version}\n${smgEnvironment !== 'prod' ? smgEnvironment : ''}`}
      </P>
    </>
  );
};

const styles = {
  header_s: [MainStyle.a_i_c, MainStyle.m_y_6],
  title_s: [MainStyle.f_s_20, MainStyle.italic, MainStyle.f_w_800],
  btn_text: [
    MainStyle.Barlow700, MainStyle.f_s_10, MainStyle.l_h_12, MainStyle.t_t_u, MainStyle.c_white, MainStyle.t_a_c
  ],
  btn_shadow: {
    "shadowOffset": {"width": 0, "height": 4}, "shadowRadius": 4, "shadowColor": "rgba(0, 0, 0, 0.25)",
    "shadowOpacity": 1
  }
};
